import * as server from "@/utils/http"

export const _page = params => server.get("/inspect-order/page", params);
export const _get = params => server.get("/inspect-order/get", params);
export const _upload = params => server.postfrom("/inspect-order/upload", params);
export const _export=params=>server.download('/inspect-order/export',params);
export const _bloodTest=params=>server.download('/inspect-order/blood-test',params);
export const _template=params=>server.download('/inspect-order/template',params);
export const _print=params=>server.get("/inspect-order/print", params);
export const _push=params=>server.postfrom('/inspect-order/push',params);
export const _pull=params=>server.postfrom('/inspect-order/pull',params);
export const _cancel=params=>server.postfrom('/inspect-order/cancel',params);
export const _clear=params=>server.postfrom('/inspect-order/clear',params);
export const _batchPush=params=>server.postfrom('/inspect-order/batchPush',params);
export const _batchPull=params=>server.postfrom('/inspect-order/batchPull',params);
export const _batchCancel=params=>server.postfrom('/inspect-order/batchCancel',params);
export const _batchClear=params=>server.postfrom('/inspect-order/batchClear',params);
export const _batchPrint=params=>server.postfrom('/inspect-order/batchPrint',params);
export const _inspect=params=>server.get('/inspect-order/inspect',params);
export const _bloodDraw=params=>server.get('/inspect-order/bloodDraw',params);
export const _cancelBloodDraw=params=>server.get('/inspect-order/cancelBloodDraw',params);
export const _reject=params=>server.get('/inspect-order/rejectbloodDraw',params);
export const _cancelReject=params=>server.get('/inspect-order/cancelReject',params);

